/* eslint-disable camelcase */
import assign from "lodash/fp/assign";
import first from "lodash/fp/first";
import isString from "lodash/fp/isString";
import isNil from "lodash/fp/isNil";
import groupBy from "lodash/fp/groupBy";
import dialogCtrl from "./dialog/dialog.controller";
import dialogTmpl from "./dialog/dialog.html";
import constants from "../../core/constants";
import pinDialogCtrl from "./pinDialog/pinDialog.controller";
import pinDialogTmpl from "./pinDialog/pinDialog.html";
import vacationDialogCtrl from "./vacationDialog/vacationDialog.controller";
import vacationDialogTmpl from "./vacationDialog/vacationDialog.html";
import loanDialogCtrl from "./loanDialog/loanDialog.controller";
import loanDialogTmpl from "./loanDialog/loanDialog.html";
import captainDeactivationDialogCtrl from "./captainDeactivationDialog/captainDeactivationDialog.controller";
import captainDeactivationDialogTemplate from "./captainDeactivationDialog/captainDeactivationDialog.html";
import apis from "../../core/apis";
import moment from "moment";

import callDialog from "./callDialog/callDialog.html";
import callController from "./callDialog/callDialog.controller";

class Controller {
  constructor(
    $injector,
    $stateParams,
    $timeout,
    $mdDialog,
    $transitions,
    Upload,
    Mapie,
    GoogleMaps,
    PureCloud,
    Lists
  ) {
    "ngInject";

    this.Mapie = Mapie;
    this.Upload = Upload;
    this.lists = Lists.all;
    this.$timeout = $timeout;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.$transitions = $transitions;
    this.Bus = $injector.get("Bus");
    this.Ride = $injector.get("Ride");
    this.Events = $injector.get("Events");
    this.Captain = $injector.get("Captain");
    this.Messages = $injector.get("Messages");
    this.Schedule = $injector.get("Schedule");
    this.CaptainPlan = $injector.get("CaptainPlan");
    this.ActionLists = $injector.get("ActionLists");
    this.RideTransforms = $injector.get("RideTransforms");
    this.RouteTransforms = $injector.get("RouteTransforms");
    this.CaptainTransforms = $injector.get("CaptainTransforms");
    this.BusesTransforms = $injector.get("BusesTransforms");
    this.Socket = $injector.get("Socket");
    this.sections = $injector.get("Sections").fleetSections;

    this.captainResourceId = this.$stateParams.id;
    this.rideParams = {
      captain: this.$stateParams.id,
      finances: true,
      isCityRequired: false,
    };
    this.rideTodayParams = {
      captain: this.$stateParams.id,
      isCityRequired: false,
      date: moment().startOf("day").utc().format(),
    };
    this.invoicesParams = {
      captain: this.$stateParams.id,
      isCityRequired: false,
    };
    this.loanParams = { captain: this.$stateParams.id };
    this.captainBidsParams = {
      id: this.$stateParams.id,
      isCityRequired: false,
    };
    this.limitOptions = constants.tableLimitOptions;

    // Load google maps scripts
    this.googleMapsUrl = GoogleMaps.getSource();
    this.rideResourceActions = this.ActionLists.all.rideActions;
    this.rideInvoiceActions = this.ActionLists.all.createRideInvoiceItem;
    this.invoiceFields = $injector.get("InvoicesTransforms").fields;
    this.ridesFields = $injector.get("RidesTransforms").fields;
    this.rideInvoicesFields = $injector.get("RidesTransforms").invoicesFields;
    this.transactionsField = $injector.get(
      "CaptainTransforms"
    ).captainTransactionFields;
    this.transactionResourceActions = $injector.get(
      "ActionLists"
    ).all.captainTransactionActions;
    this.rideTodayFields = this.ridesFields.filter(
      (info) => info.name !== "bus_type"
    );
    this.loanFields = $injector.get("CaptainTransforms").captainLoanFields;
    this.bidsFields = $injector.get("CaptainTransforms").captainBidsFields;
    this.biddingActions = [
      {
        title: "Go to Plan Details",
        method: ({ plan_link }) => {
          window.open(plan_link, "_blank");
        },
      },
      {
        title: "Go to Bidding Details",
        method: ({ bidding_link }) => {
          window.open(bidding_link, "_blank");
        },
      },
    ];
    this.noteEvent = this.Events.getUpdateEvent("captainNote");
    this.onUpdateEvent = this.Events.getUpdateEvent("captain");
    this.onUpdateCompanyEvent = this.Events.getUpdateEvent("captainCompany");
    this.onUpdateContractorEvent = this.Events.getUpdateEvent(
      "captainContractor"
    );
    this.onAddPlanEvent = this.Events.getAddEvent("captainPlan");
    this.onUpdatePlanEvent = this.Events.getUpdateEvent("captainPlan");
    this.onRequestFileUrlEvent = this.Events.eventsType.onRequestFileUrlEvent;
    this.onUpdateActiveEvent = this.Events.getUpdateEvent("captainActive");
    this.onUpdateExtraInfoEvent = this.Events.getUpdateEvent("extraInfo");
    this.successUpdateExtraInfoEvent = this.Events.successUpdateEvent(
      "extraInfo"
    );
    this.onDocumentUploadedEvent = this.Events.successUpdateEvent(
      "documentUploaded"
    );
    this.captainLocationEvent = this.Events.getCaptianLocationEvent(
      this.$stateParams.id
    );
    this.showCaptainPlanDialogEvent = this.Events.getAddEvent("captainPlan");

    // PureCloud Config
    this.pureCloudSDK = PureCloud;
    this.pureCloudClientId = "";
    this.pureCloudRedirectUri = "";
    this.pureCloudState = "";
    this.callState = "";
  }

  $onInit() {
    const socket = this.Socket.dashboard();
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.updateMarker = (data) => {
      if (!data) return;
      if (isString(data)) data = JSON.parse(data);

      let locationUpdated;
      const lat = data.location.lat;
      const lng = data.location.lng;
      const date = moment(data.date).format(constants.dateTimeFormat);

      this.mapCenter = this.Mapie.pointSrt(data);
      this.$timeout(() => {
        this.marker = [lat, lng];
        this.bearing = data.bearing;
        this.time = date;

        if (!locationUpdated) {
          locationUpdated = true;
        }
      });
    };
    this.Captain.get(this.$stateParams.id).$promise.then(
      (response) => {
        this.captain = this.CaptainTransforms.justify(response);
        this.lastForcedUpdate = moment(this.captain.force_last_updated).format(
          constants.dateTimeFormat
        );
        this.getCaptainSchedules(true, this.captain, 1, 10);
        this.getCaptainSchedules(false, this.captain, 1, 10);
        this.force_enabled_gps =
          !isNil(this.captain.gps_force_enabled) &&
          this.captain.gps_force_enabled.value
            ? "yes"
            : "no";
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );

    this.Captain.getVerificationState(this.$stateParams.id)
      .$promise.then((response) => {
        this.verificationState = this.CaptainTransforms.justifyVerificationState(
          response
        );
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));

    this.Captain.getBackgroundCheckState(this.$stateParams.id).$promise.then(
      (response) => {
        this.backgroundCheckState = response.background_check;
      }
    );

    this.Bus.getAll({
      captain: this.$stateParams.id,
      isCityRequired: false,
    }).$promise.then(
      (response) => {
        this.buses = this.BusesTransforms.justify(response.hits);
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );

    this.Captain.notes({ captain: this.$stateParams.id }).$promise.then(
      (response) => {
        this.notes = this.CaptainTransforms.justifyNotes(response.hits);
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );

    this.Ride.punctuality({ captainId: this.$stateParams.id }).$promise.then(
      (response) => {
        this.captainPunctuality = response;
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );

    this.CaptainPlan.get(this.$stateParams.id).$promise.then(
      (response) => {
        this.captainPlan = this.CaptainTransforms.justifyPlans(response);
      },
      () => {
        this.showCaptainPlanDialog = true;
      }
    );

    this.onMapInit = (map) => {
      this.map = map;
    };

    this.$transitions.onStart({}, () => {
      socket.disconnect();
    });

    socket.on("connect", () =>
      socket.emit("captain:subscribe", { captainId: this.$stateParams.id })
    );

    socket.on("captain:location:update", (data) => {
      this.Events.emit(this.captainLocationEvent, data.payload);
    });

    socket.on("reconnect_attempt", () => {
      const transports = ["websocket"];
      socket.io.opts.transports = transports;
    });

    this.Events.on(this.onUpdateEvent, this.onUpdate.bind(this));
    this.Events.on(this.onUpdateCompanyEvent, this.onUpdateCompany.bind(this));
    this.Events.on(
      this.onUpdateContractorEvent,
      this.onUpdateContractor.bind(this)
    );
    this.Events.on(
      this.onRequestFileUrlEvent,
      this.onRequestFileUrl.bind(this)
    );
    this.Events.on(this.onAddPlanEvent, this.onAddPlan.bind(this));
    this.Events.on(this.onUpdatePlanEvent, this.onUpdatePlan.bind(this));
    this.Events.on(this.noteEvent, this.onNoteUpdate.bind(this));
    this.Events.on(
      this.onUpdateActiveEvent,
      this.onNoteUpdateActive.bind(this)
    );
    this.Events.on(this.captainLocationEvent, this.updateMarker.bind(this));
    this.Events.on(
      this.onUpdateExtraInfoEvent,
      this.onUpdateExtraInfo.bind(this)
    );
    this.Events.on(
      this.onDocumentUploadedEvent,
      this.onDocumentUploaded.bind(this)
    );

    // PureCloud Config
    this.pureCloudClientId = constants.pureCloudClientId;
    this.pureCloudClientRedirectUri = `${location.origin}${constants.pureCloudClientRedirectUri}`;
    this.pureCloudState = `captain-${this.captainResourceId}`;
    const params = {};
    if (window.location.hash) {
      location.hash
        .substring(1)
        .split("&")
        .forEach((inst) => {
          const temp = inst.split("=");
          params[temp[0]] = temp[1];
        });
      this.purecloudToken = params.purecloud_token;
      setTimeout(() => {
        this.Events.emit(this.successNotificationEvent, {
          message: "Authentication .. Done",
        });
      }, 1500);
    }

    this.onActiveSchedulesPaginate = (page, limit) => {
      this.getCaptainSchedules(true, this.captain, page, limit);
    };

    this.onInActiveSchedulesPaginate = (page, limit) => {
      this.getCaptainSchedules(false, this.captain, page, limit);
    };
  }

  showCall() {
    if (this.pureCloudAccessTokenExists()) {
      this.$mdDialog.show({
        controller: callController,
        controllerAs: "$ctrl",
        template: callDialog,
        locals: {
          captain: this.captain,
          callState: this.callState,
          Events: this.Events,
        },
      });
    }
  }

  onUpdateContractor(item) {
    const hasContractor = item.name;
    const hasCompany = this.captain.company.name;

    if (hasContractor && hasCompany) {
      this.Events.emit(this.errorNotificationEvent, {
        message: "You can not have both a company and a contractor",
      });
    } else {
      this.onUpdate(item);
    }
  }

  onUpdateCompany(item) {
    const hasCompany = item.name;
    const hasContractor = this.captain.contractor.name;

    if (hasCompany && hasContractor) {
      this.Events.emit(this.errorNotificationEvent, {
        message: "You can not have both a company and a contractor",
      });
    } else {
      this.onUpdate(item);
    }
  }

  onUpdate(item) {
    let request;
    let value =
      item.value || (item.name && item.name._id) || item._id || item.name;
    if (item.value === "true") value = true;
    if (item.value === "false") value = false;
    if (item.value === null) value = null;

    const updatedItem = { [item.key]: value };

    if (item.methodName) {
      request = this.Captain.updateAction(
        this.$stateParams.id,
        item.methodName,
        updatedItem
      ).$promise;
    } else {
      request = this.Captain.update(this.$stateParams.id, updatedItem).$promise;
    }

    request.then(
      (response) => {
        this.captain = this.CaptainTransforms.justify(response);
        this.Events.emit(this.successNotificationEvent, {
          message: `Your captain "${item.key}" has been updated successfully`,
        });
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
  onRequestFileUrl(params) {
    params.isCityRequired = false;
    this.Captain.getDownloadLink(this.captainResourceId, params).$promise.then(
      (response) => {
        window.open(response.document_url, "_blank");
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  onNoteUpdate(note) {
    const comment = note.comment.value;
    this.Captain.updateAction(this.$stateParams.id, "add_note", {
      comment,
    }).$promise.then(
      (response) => {
        this.Events.emit(this.successNotificationEvent, {
          message: "Your note has been added successfully.",
        });
        this.notes[note.index] = first(
          this.CaptainTransforms.justifyNotes([response])
        );
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
  onDocumentUploaded(response) {
    this.captain = this.CaptainTransforms.justify(response);
    this.lastForcedUpdate = moment(this.captain.force_last_updated).format(
      constants.dateTimeFormat
    );
    this.force_enabled_gps =
      !isNil(this.captain.gps_force_enabled) &&
      this.captain.gps_force_enabled.value
        ? "yes"
        : "no";
  }

  assignGarage(garage, cb) {
    this.Captain.assignGarage(this.captainResourceId, garage).$promise.then(
      (response) => {
        this.captain = this.CaptainTransforms.justify(response);
        this.captain.garage.coordinates.isDisabled = true;
        this.Events.emit(this.successNotificationEvent, {
          message: "Garage is update successfully",
        });
        if (typeof cb === "function") cb();
      },
      (response) => {
        if (isNil(this.captainPlan) || isNil(this.captainPlan.basic_plan)) {
          this.Events.emit(this.showCaptainPlanDialogEvent);
        }
        this.Events.emit(this.errorNotificationEvent, response.data);
      }
    );
  }

  onAddPlan(options) {
    const { garage } = options;
    const assignPlan = (options) => {
      this.CaptainPlan.post(options).$promise.then(
        (response) => {
          this.captainPlan = this.CaptainTransforms.justifyPlans(response);
          this.Events.emit(
            this.successNotificationEvent,
            this.Messages.addMessage("captain plan")
          );
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    };
    const garageLocation = garage ? garage.value : undefined;
    if (isNil(garageLocation)) {
      assignPlan(options);
    } else {
      this.assignGarage(garageLocation, () => {
        assignPlan(options);
      });
    }
  }

  onUpdatePlan(options) {
    let canUpdateErrorMsg;
    const canUpdateChecker = () => {
      if (
        options.key === "variable_plan" &&
        Object.keys(this.captain.garage.coordinates.value).length !== 2
      ) {
        canUpdateErrorMsg =
          "Captain cannot have a variable plan without a garage location";
        return false;
      }
      return true;
    };
    if (options.key === "garage") {
      this.assignGarage(options.value.coordinates);
      return;
    }

    const params = {};
    let selected;
    if (isNil(options.name)) {
      selected = null;
    } else {
      selected = options.name._id ? options.name._id : options._id;
    }
    params[options.key] = selected;
    if (!isNil(options.extraParams)) {
      Object.assign(params, { ...options.extraParams });
    }
    if (canUpdateChecker()) {
      this.CaptainPlan.update(this.captainPlan._id.value, params).$promise.then(
        (response) => {
          this.Events.emit(this.successNotificationEvent, {
            message: "Captain plan is updated successfully",
          });
          this.captainPlan = this.CaptainTransforms.justifyPlans(response);
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    } else {
      this.Events.emit(this.errorNotificationEvent, canUpdateErrorMsg);
    }
  }

  onNoteUpdateActive(options) {
    const method = options.value === false ? "block" : "unblock";
    this.Captain.updateAction(this.$stateParams.id, method).$promise.then(
      (response) => {
        this.captain = this.CaptainTransforms.justify(response);
        this.Events.emit(this.successNotificationEvent, {
          message: `Captain has been ${method}ed successfully`,
        });
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  onUpdateExtraInfo(options) {
    const updatedItem = { extra_info: options.info };
    const request = this.Captain.updateAction(
      this.$stateParams.id,
      options.methodName,
      updatedItem
    ).$promise;

    request.then(
      (response) => {
        this.captain = this.CaptainTransforms.justify(response);
        this.Events.emit(this.successUpdateExtraInfoEvent);
        this.Events.emit(this.successNotificationEvent, {
          message:
            'Your captain "Extra Information" has been updated successfully',
        });
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  getCaptainSchedules(active, captain, page, limit) {
    this.Schedule.getAll({
      captain: this.$stateParams.id,
      active,
      page,
      limit,
      isCityRequired: false,
    }).$promise.then(
      (response) => {
        const schedules = this.RouteTransforms.justifySchedule(
          response.hits,
          captain.city.timezone
        );
        if (active) {
          this.activeSchedulesLoaded = true;
          this.numberOfSchedules = response.total;
          this.schedules = groupBy("route.uniqueName")(schedules);
        } else {
          this.inActiveSchedulesLoaded = true;
          this.inActiveSchedules = groupBy("route.uniqueName")(schedules);
          this.numberOfInActiveSchedules = response.total;
        }
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  handleDeactivation() {
    const deactivateDialog = {
      controllerAs: "$ctrl",
      controller: captainDeactivationDialogCtrl,
      template: captainDeactivationDialogTemplate,
      clickOutsideToClose: true,
      locals: {
        captainName: this.captain.name.value,
      },
    };

    this.$mdDialog.show(deactivateDialog).then((params) => {
      const { note, reasons } = params;
      this.Captain.updateAction(this.$stateParams.id, "block", {
        note,
        reasons,
      }).$promise.then(
        (response) => {
          this.captain = this.CaptainTransforms.justify(response);
          this.Events.emit(this.successNotificationEvent, {
            message: `Captain is ${params.type}d successfully`,
          });
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    });
  }

  handleReEnrollment() {
    const confirm = this.$mdDialog
      .confirm()
      .title("Are you sure you want to re enroll captain?")
      .ok("Confirm")
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(() => {
      this.Captain.updateAction(this.$stateParams.id, "unblock").$promise.then(
        (response) => {
          this.captain = this.CaptainTransforms.justify(response);
          this.Events.emit(this.successNotificationEvent, {
            message: "Captain re enrolled successfully",
          });
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    });
  }

  handleAddLoan() {
    const captainId = this.$stateParams.id;
    const add = {
      controller: loanDialogCtrl,
      controllerAs: "$ctrl",
      template: loanDialogTmpl,
      locals: {
        captainId,
      },
    };

    this.$mdDialog.show(add);
  }

  confirmDebt() {
    const confirm = this.$mdDialog.show({
      controller: dialogCtrl,
      controllerAs: "$ctrl",
      template: dialogTmpl,
      locals: {},
    });

    confirm.then(
      (obj) => {
        const confirm = this.$mdDialog
          .confirm()
          .title(
            `Are you sure you want to confirm receiving "${obj}" ${this.captain.city.currency.value}?`
          )
          .textContent(`Captain: ${this.captain.name.value}`)
          .ok("Confirm")
          .cancel("Cancel");

        this.$mdDialog.show(confirm).then(
          () => {
            const amount = assign({}, { amount: obj * constants.currencyBy });

            this.Captain.deductDebt(this.$stateParams.id, {
              amount,
            }).$promise.then(
              () => {
                this.Events.emit(this.successNotificationEvent, {
                  message: "Captain debt has been confirmed successfully",
                });
              },
              (response) =>
                this.Events.emit(this.errorNotificationEvent, response.data)
            );
          },
          () => {}
        );
      },
      () => {}
    );
  }

  updatePin() {
    const update = this.$mdDialog.show({
      controller: pinDialogCtrl,
      controllerAs: "$ctrl",
      template: pinDialogTmpl,
    });

    update.then(
      (obj) => {
        const confirm = this.$mdDialog
          .confirm()
          .title(`Are you sure you want to change captain pin to "${obj}"?`)
          .textContent(`Captain: ${this.captain.name.value}`)
          .ok("Confirm")
          .cancel("Cancel");

        this.$mdDialog.show(confirm).then(
          () => {
            const pin = obj;

            this.Captain.updateAction(this.$stateParams.id, "update_pin", {
              pin,
            }).$promise.then(
              () => {
                this.Events.emit(this.successNotificationEvent, {
                  message: "Captain pin has been changed successfully",
                });
              },
              (response) =>
                this.Events.emit(this.errorNotificationEvent, response.data)
            );
          },
          () => {}
        );
      },
      () => {}
    );
  }

  addVacation() {
    const captainId = this.$stateParams.id;
    const add = {
      controller: vacationDialogCtrl,
      controllerAs: "$ctrl",
      template: vacationDialogTmpl,
      locals: {
        captainId,
      },
    };

    this.$mdDialog.show(add);
  }

  onPictureChange() {
    if (this.picture) {
      const data = { picture: this.picture };
      const url = apis.captain + this.$stateParams.id + "/update_picture";

      this.Upload.upload({
        method: "POST",
        url,
        data,
      }).then(
        (response) => {
          this.Events.emit(this.successNotificationEvent, {
            message: "Captain picture has been uploaded successfully",
          });
          this.captain = this.CaptainTransforms.justify(response.data);
        },
        (response) => {
          const message =
            response.data.message || "Can't upload your picture !";

          this.Events.emit(this.errorNotificationEvent, { message });
        }
      );
    }
  }

  handleBackgroundCheckChange() {
    this.backgroundCheckState = !this.backgroundCheckState; // Prevent default switch behavior
    const confirm = this.$mdDialog
      .confirm()
      .title(
        `Are you sure you want to ${
          !this.backgroundCheckState ? "verify" : "unverify"
        } the background check of the Captain?`
      )
      .ok("Yes")
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(() => {
      this.Captain.setBackgroundCheckState(this.$stateParams.id, {
        background_check: !this.backgroundCheckState,
      })
        .$promise.then(() => {
          this.backgroundCheckState = !this.backgroundCheckState;
          this.Events.emit(this.successNotificationEvent, {
            message: `Captain background check has been ${
              this.backgroundCheckState ? "verified" : "unverified"
            } successfully`,
          });
        })
        .catch((err) => {
          this.Events.emit(this.errorNotificationEvent, err.data);
        });
    });
  }

  onStartCall() {
    try {
      let phoneToBeCalled = "";
      // Start authentication
      this.pureCloudSDK.authenticate(
        this.pureCloudClientRedirectUri,
        this.pureCloudClientId,
        this.pureCloudState
      );

      // Start Api Call
      // adding prefix to phone number agreed on with purecloud
      switch (this.captain.phone_data.region_code) {
        case "EG":
          phoneToBeCalled = `80${this.captain.phone_data.national_number}`;
          break;
        default:
          phoneToBeCalled = `500${this.captain.phone_data.country_code}${this.captain.phone_data.national_number}`;
          break;
      }

      const response = this.pureCloudSDK.postCall(phoneToBeCalled);

      response
        .then(() => {
          this.Events.emit(this.successNotificationEvent, {
            message: "Call placed for this participant",
          });
        })
        .catch((err) => {
          this.Events.emit(this.errorNotificationEvent, {
            message: `${err.status}, Error in placing this call`,
          });
          this.$mdDialog.cancel();
        });
    } catch (err) {
      this.Events.emit(this.errorNotificationEvent, {
        message: "Error in placing this call",
      });
      this.$mdDialog.cancel();
    }
  }

  onAuthorize() {
    try {
      // Start authentication
      this.pureCloudSDK.authenticate(
        this.pureCloudClientRedirectUri,
        this.pureCloudClientId,
        this.pureCloudState
      );
    } catch (err) {
      this.Events.emit(
        this.errorNotificationEvent,
        "Error in authorizing purecloud agent"
      );
    }
  }

  pureCloudAccessTokenExists() {
    if (window.location.hash) return true;
    return false;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captain/captain.controller.js